<template>
  <div>
    <!-- 个人实名 -->
      <div v-if="formDate.companyType == '01' && !formDate.idNo" style="width: 500px; margin: 30px auto; text-align: center;">
        <el-form ref="form" :model="form" label-position="left" label-width="110px" :rules="cRules">
          <el-form-item label="手机号" prop="mobile">
            <div style="text-align:left">{{form.mobile}}</div>
          </el-form-item>
          <el-form-item class="w-70" label="姓名" prop="name">
            <el-input v-model="form.name" placeholder="请输入"></el-input>
          </el-form-item>          
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="form.idCard" placeholder="请输入" />
          </el-form-item>
        </el-form>
        <div>
          <el-button class="s-but" :type="subject == 'gjzcy'?'orange':'blue'" @click="submitForm('form')" :loading="butLoading">提 交</el-button>
        </div>
      </div>

    <!-- 个人信息 -->
    <div class="d-form" v-else-if="formDate.companyType == '01'">
      <div class="tag">
        <img src="../../assets/img/tag.png" width="52" />
      </div>
      <div class="form-body b-01">
        <img :src="require(`../../assets/img/p-${subject}.png`)" width="202px" height="147px" />
        <div style="width: 100%">
          <h3 class="form-title" :class="`t-${subject}`">个人信息</h3>
          <table class="form-table" cellspacing="0" cellpadding="0">
              <tr>
                  <th width="12%">姓名：</th>
                  <td width="88%"> {{formDate.companyCn}}</td>
              </tr>
              <tr>
                  <th>手机号：</th>
                  <td> {{formDate.mobile}}</td>
              </tr>
              <tr>
                  <th>身份证号：</th>
                  <td>{{formDate.idNo}}</td>
              </tr>
          </table>
        </div>
      </div>      
    </div>

    <!-- 企业信息 -->
    <div class="d-form" v-if="formDate.companyType == '02'">
      <div class="tag">
        <img src="../../assets/img/tag.png" width="52" />
      </div>
      <div class="form-body b-02">
        <img :src="require(`../../assets/img/c-${subject}.png`)" width="217px" height="243px" />
        <div style="width: 100%">
          <h3 class="form-title" :class="`t-${subject}`">企业信息</h3>
          <table class="form-table" cellspacing="0" cellpadding="0">
              <tr>
                  <th width="20%">单位全称</th>
                  <td width="80%"> {{formDate.companyCn}}</td>
              </tr>
              <tr>
                  <th>单位类型</th>
                  <td> {{formatType(formDate.compType)}}</td>
              </tr>
              <tr>
                  <th>统一社会信用代码</th>
                  <td>{{formDate.job}}</td>
              </tr>
              <tr>
                  <th>法定代表人姓名</th>
                  <td>{{formDate.legalPerson}}</td>
              </tr>
              <tr>
                  <th>单位注册地</th>
                  <td>
                    <el-cascader
                        class="no-bg"
                        disabled  
                        style="width: 100%"
                        placeholder=""
                        v-model="formDate.areaCode"
                        :options="areaOptions">
                    </el-cascader>
                  </td>
              </tr>
              <tr>
                  <th>单位地址详址</th>
                  <td>{{formDate.compAddr}}</td>
              </tr>
              <tr>             
                  <th>联系人</th>
                  <td>{{formDate.agencyPerson}}</td>
              </tr>
              <tr>
                  <th>联系人手机号</th>
                  <td>{{formDate.mobile}}</td>
              </tr>
              <tr>             
                  <th>联系人邮箱</th>
                  <td>{{formDate.orgEmail}}</td>
              </tr>
              <tr>
                  <th>入会申请书</th>
                  <td>
                    <div><a target="_bank" :href="formDate.fileAttach2">入会申请书</a></div>
                  </td>           
              </tr>
              <tr>
                  <th>营业执照</th>
                  <td>
                    <div><a target="_bank" :href="formDate.licenseFile">营业执照</a></div>
                  </td>
              </tr>
          </table>
        </div>
      </div> 
      
    </div>
  </div>
</template>

<script>
import area from '@/utils/area';
import { type } from 'os';
export default {
  name: "userInf",
  props: ["subject"],
  data() {
    return {
      areaOptions:area,
      butLoading: false,
      form: {},
      cRules: {
        name: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入', trigger: 'blur' }
        ]
      },
      formDate: {},
      account: sessionStorage.account,
      typeOption: [
        {
          val: 'financialInstitution',
          label: '金融机构'
        },
        {
          val: 'likeFinancialInstitution',
          label: '类金融机构'
        },
        {
          val: 'generalorganization',
          label: '普通机构'
        }
      ]
    }
  },
  created() {
    this.getInf()
  },
  methods: {
    formatType(val){  
      if(val){
        return this.typeOption.filter(item=>item.val == val)[0].label
      }        
    },
    getInf(){
      this.$api.api.getInfoByAccount({account: this.account}).then(response => {
        this.formDate = response.data
        if(this.formDate.companyType == '02'){
          // 入会申请书
          let fileAttach2File = response.data.userAttrValues.filter(item => {
            return item.attrKey == 'fileAttach2'
          })
          this.formDate.fileAttach2 =fileAttach2File.length >0 ? fileAttach2File[0].attrValue :''
          // 营业执照
          let licenseFile = response.data.userAttrValues.filter(item => {
            return item.attrKey == 'licenseFile'
          })
          this.formDate.licenseFile =licenseFile.length >0 ? licenseFile[0].attrValue :''

          // 邮箱
          let orgEmail = response.data.userAttrValues.filter(item => {
            return item.attrKey == 'orgEmail'
          })
          this.formDate.orgEmail =orgEmail[0]?orgEmail[0].attrValue : ''
          // 企业类型
          let compType = response.data.userAttrValues.filter(item => {
            return item.attrKey == 'compType'
          })
          this.formDate.compType =compType[0]?compType[0].attrValue : ''
          // 省
          this.formDate.areaCode = [this.formDate.compProvinceCode,this.formDate.compCityCode,this.formDate.compDistrictCode]
        }else {
          this.form.mobile = response.data.mobile
        }
      });
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
        if(valid) {
          let _data = new FormData();
					_data.append('account', this.account)
					_data.append('idCard', this.form.idCard)
					_data.append('name', this.form.name)
          this.$api.api.verify(_data).then(response => {
            // console.info(response)
            if(response.code == '00000000'){
              this.$message.success('身份证认证成功！');
              this.getInf()
            }else {
              this.$message.error(response.msg || response.message)
            }
          });
        }
      })
    }
  }
}
</script>
